import React from 'react';
import type { ProductFeatureCardProps } from 'Components/widgets/product-feature-card/ProductFeatureCard';
import { ProductFeatureCard } from 'Components/widgets/product-feature-card/ProductFeatureCard';
import { ProductInformationSliderContainer } from 'Components/widgets/product-information-slider/ProductInformationSlider.container';
type Props = {
  items: Array<ProductFeatureCardProps>;
  queryLayer: string;
  renderDetail: (data: unknown) => React.ReactNode;
  sliderIndex: number;
};
export const ProductFeaturesSlider = ({ items, ...rest }: Props) => (
  <ProductInformationSliderContainer {...rest}>
    {items.map((item) => (
      <ProductFeatureCard key={item.title} {...item} />
    ))}
  </ProductInformationSliderContainer>
);
